import { getLocale } from "../runtime";

const sv_mtcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Malta`
};

const mtcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_mtcountryenglish(inputs)
	return "mtCountryEnglish";
};

export { mtcountryenglish as "mtCountryEnglish" };